// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { Provider, AppointmentSlot, Location, Address } from '../types'; // eslint-disable-line no-unused-vars

/** @typedef {{
  provider: Provider,
  appointmentSlot?:AppointmentSlot,
  specialtyName: string,
  location: Location,
  endAddress: Address,
  patientInstructions?: string,
  referralProviderInstructions?: string
}} ReferralDetailsPropsType */

/** @type { React.ValidationMap<ReferralDetailsPropsType> } */
const propTypes = {
  provider: PropTypes.object,
  appointmentSlot: PropTypes.object,
  specialtyName: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  endAddress: PropTypes.object,
  patientInstructions: PropTypes.string,
  referralProviderInstructions: PropTypes.string,
};

/** @type { StatelessComponent<ReferralDetailsPropsType> } */
const ReferralDetails = ({
  provider,
  appointmentSlot,
  specialtyName,
  location,
  endAddress,
  patientInstructions,
  referralProviderInstructions,
}) => (
  <table className="table table-bordered table-striped">
    <thead>
      <tr>
        <th>Field</th>
        <th>Info</th>
      </tr>
    </thead>
    <tbody>
      {appointmentSlot && [
        <tr key="time">
          <td>Time:</td>
          <td style={{ color: 'rgb(80,170,80)', fontSize: '20px' }}>
            <b>{appointmentSlot.displayStartTime}</b>
          </td>
        </tr>,
        <tr key="date">
          <td>Date:</td>
          <td style={{ color: 'rgb(80,170,80)', fontSize: '20px' }}>
            <b>{appointmentSlot.displayDate}</b>
          </td>
        </tr>,
      ]}
      <tr>
        <td>Provider:</td>
        <td style={{ color: 'rgb(80,170,80)', fontSize: '20px' }}>
          <b>{provider.name}</b>
        </td>
      </tr>
      <tr>
        <td>Specialty:</td>
        <td>{specialtyName}</td>
      </tr>
      <tr>
        <td>Phone:</td>
        <td>
          <b>{location.phone}</b>
        </td>
      </tr>
      {endAddress && [
        <tr key="address">
          <td>Address:</td>
          <td>
            <b>{endAddress.streetAddress}</b>
          </td>
        </tr>,
        <tr key="city">
          <td>City:</td>
          <td>
            <b>{endAddress.city}</b>
          </td>
        </tr>,
        <tr key="state">
          <td>State:</td>
          <td>
            <b>{endAddress.stateName}</b>
          </td>
        </tr>,
        <tr key="zip">
          <td>Zip:</td>
          <td>
            <b>{endAddress.zip}</b>
          </td>
        </tr>,
      ]}
      {patientInstructions && (
        <tr>
          <td>Patient Instructions:</td>
          <td style={{ whiteSpace: 'pre-wrap' }}>
            <strong>{patientInstructions}</strong>
          </td>
        </tr>
      )}
      {referralProviderInstructions && (
        <tr>
          <td>Referring Provider Instructions:</td>
          <td style={{ whiteSpace: 'pre-wrap' }}>
            <strong>{referralProviderInstructions}</strong>
          </td>
        </tr>
      )}
    </tbody>
  </table>
);

ReferralDetails.displayName = 'ReferralDetails';
ReferralDetails.propTypes = propTypes;

export default ReferralDetails;
